import store from '@/store';
import * as OM from '@/Model';
import { LocalizedEntityClient } from './Services';

class _LocalizationServices {
    
    GetLocalizedValue(key: string, value: string, afterText: string = '', prevText: string = '', object: any = null): string {
        var existing = Object.keys(store.state.consts.localizedValues).indexOf(key) != -1;

        let result = prevText + value + afterText;
        
        if(existing) {
            result = store.state.consts.localizedValues[key];
        } else {
            LocalizedEntityClient.saveLocalizedValue({
                key: key,
                value: value
            }, false)
            .then(x => {
                store.state.consts.localizedValues[key] = value;
            })
            result = value;
        }
        result = this.replaceText(result, object);
        return prevText + result + afterText;
    }
    
    replaceText(text: string, object: any): string {
        if(!object)
            return text;
        
        while(text.indexOf('{{') != -1){
            var init = text.indexOf("{{");
            var end = text.indexOf("}}");
    
            if(init == -1 || end == -1)
                break;
            
            var textToReplace = text.substring(init, text.length - (text.length - end) + 2);
            var variableName = textToReplace.substring(2, textToReplace.length - 2);
            
            if(object[variableName] == null || object[variableName] == undefined){
                console.error("Variabile: " + variableName + " non esistente nell'oggetto");
                break;
            }
    
            text = text.replace(textToReplace, object[variableName]);
        }
    
        return text;
    }

    getTextFromValues(value: { [key: string]: string; }, customLang: string = "") {
        var lang = store.state.user.preferredCulture;
        if (customLang)
            lang = customLang;

        var keys = Object.keys(value);
        if (keys.indexOf(lang) == -1)
            return "";

        return value[lang];
    }

    getTextFromLocalizedValue(model: OM.LocalizedValue, customLang: string = "") {
        var values = model.values;

        if (customLang)
            return this.getTextFromValues(values, customLang);

        return this.getTextFromValues(values);
    }
}
export let LocalizationServices = new _LocalizationServices();
